exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6fc4c2c0] .supplier-table th{padding:0 3px!important}", ""]);

// exports
